const RINKEBY = {
    factoryAddress: '0xf5D915570BC477f9B8D6C0E980aA81757A3AaC36',
    exchangeAddresses: {
        addresses: [
            ['BAT', '0x9B913956036a3462330B0642B20D3879ce68b450'],
            ['DAI', '0x77dB9C915809e7BE439D2AB21032B1b8B58F6891'],
            ['MKR', '0x93bB63aFe1E0180d0eF100D774B473034fd60C36'],
            ['OMG', '0x26C226EBb6104676E593F8A070aD6f25cDa60F8D'],
            ['ZRX', '0xaBD44a1D1b9Fb0F39fE1D1ee6b1e2a14916D067D'],
        ],
        fromToken: {
            '0xDA5B056Cfb861282B4b59d29c9B395bcC238D29B': '0x9B913956036a3462330B0642B20D3879ce68b450',
            '0x2448eE2641d78CC42D7AD76498917359D961A783': '0x77dB9C915809e7BE439D2AB21032B1b8B58F6891',
            '0xF9bA5210F91D0474bd1e1DcDAeC4C58E359AaD85': '0x93bB63aFe1E0180d0eF100D774B473034fd60C36',
            '0x879884c3C46A24f56089f3bBbe4d5e38dB5788C0': '0x26C226EBb6104676E593F8A070aD6f25cDa60F8D',
            '0xF22e3F33768354c9805d046af3C0926f27741B43': '0xaBD44a1D1b9Fb0F39fE1D1ee6b1e2a14916D067D',
        },
    },
    tokenAddresses: {
        addresses: [
            ['BAT', '0xDA5B056Cfb861282B4b59d29c9B395bcC238D29B'],
            ['DAI', '0x2448eE2641d78CC42D7AD76498917359D961A783'],
            ['MKR', '0xF9bA5210F91D0474bd1e1DcDAeC4C58E359AaD85'],
            ['OMG', '0x879884c3C46A24f56089f3bBbe4d5e38dB5788C0'],
            ['ZRX', '0xF22e3F33768354c9805d046af3C0926f27741B43'],
        ],
    },
};

const MAIN = {
    factoryAddress: '0xc0a47dFe034B400B47bDaD5FecDa2621de6c4d95',
    exchangeAddresses: {
        addresses: [
            ['ANT', '0x077d52B047735976dfdA76feF74d4d988AC25196'],
            ['BAT', '0x2E642b8D59B45a1D8c5aEf716A84FF44ea665914'],
            // ['BLT', '0x0E6A53B13688018A3df8C69f99aFB19A3068D04f'],
            ['BNT', '0x87d80DBD37E551F58680B4217b23aF6a752DA83F'],
            ['C20', '0xf7b5a4b934658025390ff69db302bc7f2ac4a542'],
            ['CVC', '0x1C6c712b1F4a7c263B1DBd8F97fb447c945d3b9a'],
            ['DAI', '0x09cabEC1eAd1c0Ba254B09efb3EE13841712bE14'],
            ['DGX', '0xb92dE8B30584392Af27726D5ce04Ef3c4e5c9924'],
            ['FOAM', '0xf79cb3BEA83BD502737586A6E8B133c378FD1fF2'],
            ['FUN', '0x60a87cC7Fca7E53867facB79DA73181B1bB4238B'],
            ['GNO', '0xe8e45431b93215566BA923a7E611B7342Ea954DF'],
            ['GRID', '0x4B17685b330307C751B47f33890c8398dF4Fe407'],
            ['GUSD', '0xD883264737Ed969d2696eE4B4cAF529c2Fc2A141'],
            ['KIN', '0xb7520a5F8c832c573d6BD0Df955fC5c9b72400F7'],
            ['KNC', '0x49c4f9bc14884f6210F28342ceD592A633801a8b'],
            ['LINK', '0xF173214C720f58E03e194085B1DB28B50aCDeeaD'],
            ['LOOM', '0x417CB32bc991fBbDCaE230C7c4771CC0D69daA6b'],
            ['LPT', '0xc4a1C45D5546029Fd57128483aE65b56124BFA6A'],
            ['MANA', '0xC6581Ce3A005e2801c1e0903281BBd318eC5B5C2'],
            ['MKR', '0x2C4Bd064b998838076fa341A83d007FC2FA50957'],
            ['NEXO', '0x069C97DBA948175D10af4b2414969e0B88d44669'],
            ['NMR', '0x2Bf5A5bA29E60682fC56B2Fcf9cE07Bef4F6196f'],
            ['PAX', '0xC040d51b07Aea5d94a89Bc21E8078B77366Fc6C7'],
            ['QCH', '0x755899F0540c3548b99E68C59AdB0f15d2695188'],
            ['RDN', '0x7D03CeCb36820b4666F45E1b4cA2538724Db271C'],
            ['REN', '0x43892992B0b102459E895B88601Bb2C76736942c'],
            ['REP', '0x48B04d2A05B6B604d8d5223Fd1984f191DED51af'],
            ['RLC', '0xA825CAE02B310E9901b4776806CE25db520c8642'],
            ['RHOC', '0x394e524b47A3AB3D3327f7fF6629dC378c1494a3'],
            ['SALT', '0xC0C59cDe851bfcbdddD3377EC10ea54A18Efb937'],
            ['SNT', '0x1aEC8F11A7E78dC22477e91Ed924Fab46e3A88Fd'],
            ['SNX', '0x5d8888a212d033cff5f2e0ac24ad91a5495bad62'],
            ['SPANK', '0x4e395304655F0796bc3bc63709DB72173b9DdF98'],
            ['SUSD', '0xa1ecdcca26150cf69090280ee2ee32347c238c7b'],
            ['TKN', '0xb6cFBf322db47D39331E306005DC7E5e6549942B'],
            ['TUSD', '0x4F30E682D0541eAC91748bd38A648d759261b8f3'],
            ['USDC', '0x97deC872013f6B5fB443861090ad931542878126'],
            ['VERI', '0x17e5BF07D696eaf0d14caA4B44ff8A1E17B34de3'],
            ['BTC', '0x4d2f5cFbA55AE412221182D8475bC85799A5644b'],
            ['ETH', '0xA2881A90Bf33F03E7a3f803765Cd2ED5c8928dFb'],
            ['XCHF', '0x8dE0d002DC83478f479dC31F76cB0a8aa7CcEa17'],
            ['ZIL', '0x7dc095A5CF7D6208CC680fA9866F80a53911041a'],
            ['ZRX', '0xaE76c84C9262Cdb9abc0C2c8888e62Db8E22A0bF'],
        ],
        fromToken: {
            '0x960b236A07cf122663c4303350609A66A7B288C0': '0x077d52B047735976dfdA76feF74d4d988AC25196',
            '0x0D8775F648430679A709E98d2b0Cb6250d2887EF': '0x2E642b8D59B45a1D8c5aEf716A84FF44ea665914',
            '0x107c4504cd79C5d2696Ea0030a8dD4e92601B82e': '0x0E6A53B13688018A3df8C69f99aFB19A3068D04f',
            '0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C': '0x87d80DBD37E551F58680B4217b23aF6a752DA83F',
            '0x26E75307Fc0C021472fEb8F727839531F112f317': '0xf7b5a4b934658025390ff69db302bc7f2ac4a542',
            '0x41e5560054824eA6B0732E656E3Ad64E20e94E45': '0x1C6c712b1F4a7c263B1DBd8F97fb447c945d3b9a',
            '0x89d24A6b4CcB1B6fAA2625fE562bDD9a23260359': '0x09cabEC1eAd1c0Ba254B09efb3EE13841712bE14',
            '0x4f3AfEC4E5a3F2A6a1A411DEF7D7dFe50eE057bF': '0xb92dE8B30584392Af27726D5ce04Ef3c4e5c9924',
            '0x4946Fcea7C692606e8908002e55A582af44AC121': '0xf79cb3BEA83BD502737586A6E8B133c378FD1fF2',
            '0x419D0d8BdD9aF5e606Ae2232ed285Aff190E711b': '0x60a87cC7Fca7E53867facB79DA73181B1bB4238B',
            '0x6810e776880C02933D47DB1b9fc05908e5386b96': '0xe8e45431b93215566BA923a7E611B7342Ea954DF',
            '0x12B19D3e2ccc14Da04FAe33e63652ce469b3F2FD': '0x4B17685b330307C751B47f33890c8398dF4Fe407',
            '0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd': '0xD883264737Ed969d2696eE4B4cAF529c2Fc2A141',
            '0x818Fc6C2Ec5986bc6E2CBf00939d90556aB12ce5': '0xb7520a5F8c832c573d6BD0Df955fC5c9b72400F7',
            '0xdd974D5C2e2928deA5F71b9825b8b646686BD200': '0x49c4f9bc14884f6210F28342ceD592A633801a8b',
            '0x514910771AF9Ca656af840dff83E8264EcF986CA': '0xF173214C720f58E03e194085B1DB28B50aCDeeaD',
            '0xA4e8C3Ec456107eA67d3075bF9e3DF3A75823DB0': '0x417CB32bc991fBbDCaE230C7c4771CC0D69daA6b',
            '0x58b6A8A3302369DAEc383334672404Ee733aB239': '0xc4a1C45D5546029Fd57128483aE65b56124BFA6A',
            '0x0F5D2fB29fb7d3CFeE444a200298f468908cC942': '0xC6581Ce3A005e2801c1e0903281BBd318eC5B5C2',
            '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2': '0x2C4Bd064b998838076fa341A83d007FC2FA50957',
            '0xB62132e35a6c13ee1EE0f84dC5d40bad8d815206': '0x069C97DBA948175D10af4b2414969e0B88d44669',
            '0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671': '0x2Bf5A5bA29E60682fC56B2Fcf9cE07Bef4F6196f',
            '0x8E870D67F660D95d5be530380D0eC0bd388289E1': '0xC040d51b07Aea5d94a89Bc21E8078B77366Fc6C7',
            '0x687BfC3E73f6af55F0CccA8450114D107E781a0e': '0x755899F0540c3548b99E68C59AdB0f15d2695188',
            '0x255Aa6DF07540Cb5d3d297f0D0D4D84cb52bc8e6': '0x7D03CeCb36820b4666F45E1b4cA2538724Db271C',
            '0x408e41876cCCDC0F92210600ef50372656052a38': '0x43892992B0b102459E895B88601Bb2C76736942c',
            '0x1985365e9f78359a9B6AD760e32412f4a445E862': '0x48B04d2A05B6B604d8d5223Fd1984f191DED51af',
            '0x607F4C5BB672230e8672085532f7e901544a7375': '0xA825CAE02B310E9901b4776806CE25db520c8642',
            '0x168296bb09e24A88805CB9c33356536B980D3fC5': '0x394e524b47A3AB3D3327f7fF6629dC378c1494a3',
            '0x4156D3342D5c385a87D264F90653733592000581': '0xC0C59cDe851bfcbdddD3377EC10ea54A18Efb937',
            '0x744d70FDBE2Ba4CF95131626614a1763DF805B9E': '0x1aEC8F11A7E78dC22477e91Ed924Fab46e3A88Fd',
            '0x42d6622deCe394b54999Fbd73D108123806f6a18': '0x4e395304655F0796bc3bc63709DB72173b9DdF98',
            '0xaAAf91D9b90dF800Df4F55c205fd6989c977E73a': '0xb6cFBf322db47D39331E306005DC7E5e6549942B',
            '0x8dd5fbCe2F6a956C3022bA3663759011Dd51e73E': '0x4F30E682D0541eAC91748bd38A648d759261b8f3',
            '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48': '0x97deC872013f6B5fB443861090ad931542878126',
            '0x8f3470A7388c05eE4e7AF3d01D8C722b0FF52374': '0x17e5BF07D696eaf0d14caA4B44ff8A1E17B34de3',
            '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599': '0x4d2f5cFbA55AE412221182D8475bC85799A5644b',
            '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2': '0xA2881A90Bf33F03E7a3f803765Cd2ED5c8928dFb',
            '0xB4272071eCAdd69d933AdcD19cA99fe80664fc08': '0x8dE0d002DC83478f479dC31F76cB0a8aa7CcEa17',
            '0x05f4a42e251f2d52b8ed15E9FEdAacFcEF1FAD27': '0x7dc095A5CF7D6208CC680fA9866F80a53911041a',
            '0xE41d2489571d322189246DaFA5ebDe1F4699F498': '0xaE76c84C9262Cdb9abc0C2c8888e62Db8E22A0bF',
            '0x3772f9716Cf6D7a09edE3587738AA2af5577483a': '0x5d8888a212d033cff5f2e0ac24ad91a5495bad62',
            '0x0cbe2df57ca9191b64a7af3baa3f946fa7df2f25': '0xa1ecdcca26150cf69090280ee2ee32347c238c7b',
        },
    },
    tokenAddresses: {
        addresses: [
            ['ANT', '0x960b236A07cf122663c4303350609A66A7B288C0'],
            ['BAT', '0x0D8775F648430679A709E98d2b0Cb6250d2887EF'],
            // ['BLT', '0x107c4504cd79C5d2696Ea0030a8dD4e92601B82e'],
            ['BNT', '0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C'],
            // ['C20', '0x26E75307Fc0C021472fEb8F727839531F112f317'],
            ['CVC', '0x41e5560054824eA6B0732E656E3Ad64E20e94E45'],
            ['DAI', '0x89d24A6b4CcB1B6fAA2625fE562bDD9a23260359'],
            // ['DGX', '0x4f3AfEC4E5a3F2A6a1A411DEF7D7dFe50eE057bF'],
            // ['FOAM', '0x4946Fcea7C692606e8908002e55A582af44AC121'],
            ['FUN', '0x419D0d8BdD9aF5e606Ae2232ed285Aff190E711b'],
            ['GNO', '0x6810e776880C02933D47DB1b9fc05908e5386b96'],
            // ['GRID', '0x12B19D3e2ccc14Da04FAe33e63652ce469b3F2FD'],
            ['GUSD', '0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd'],
            ['KIN', '0x818Fc6C2Ec5986bc6E2CBf00939d90556aB12ce5'],
            ['KNC', '0xdd974D5C2e2928deA5F71b9825b8b646686BD200'],
            ['LINK', '0x514910771AF9Ca656af840dff83E8264EcF986CA'],
            ['LOOM', '0xA4e8C3Ec456107eA67d3075bF9e3DF3A75823DB0'],
            ['LPT', '0x58b6A8A3302369DAEc383334672404Ee733aB239'],
            ['MANA', '0x0F5D2fB29fb7d3CFeE444a200298f468908cC942'],
            ['MKR', '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2'],
            ['NEXO', '0xB62132e35a6c13ee1EE0f84dC5d40bad8d815206'],
            // ['NMR', '0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671'],
            ['PAX', '0x8E870D67F660D95d5be530380D0eC0bd388289E1'],
            // ['QCH', '0x687BfC3E73f6af55F0CccA8450114D107E781a0e'],
            // ['RDN', '0x255Aa6DF07540Cb5d3d297f0D0D4D84cb52bc8e6'],
            // ['REN', '0x408e41876cCCDC0F92210600ef50372656052a38'],
            ['REP', '0x1985365e9f78359a9B6AD760e32412f4a445E862'],
            ['RLC', '0x607F4C5BB672230e8672085532f7e901544a7375'],
            ['RHOC', '0x168296bb09e24A88805CB9c33356536B980D3fC5'],
            ['SALT', '0x4156D3342D5c385a87D264F90653733592000581'],
            ['SNT', '0x744d70FDBE2Ba4CF95131626614a1763DF805B9E'],
            // ['SNX', '0x3772f9716Cf6D7a09edE3587738AA2af5577483a'],
            // ['SPANK', '0x42d6622deCe394b54999Fbd73D108123806f6a18'],
            // ['SUSD', '0x0cbe2df57ca9191b64a7af3baa3f946fa7df2f25'],
            ['TKN', '0xaAAf91D9b90dF800Df4F55c205fd6989c977E73a'],
            ['TUSD', '0x8dd5fbCe2F6a956C3022bA3663759011Dd51e73E'],
            ['USDC', '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'],
            ['VERI', '0x8f3470A7388c05eE4e7AF3d01D8C722b0FF52374'],
            ['BTC', '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599'],
            ['ETH', '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
            ['XCHF', '0xB4272071eCAdd69d933AdcD19cA99fe80664fc08'],
            ['ZIL', '0x05f4a42e251f2d52b8ed15E9FEdAacFcEF1FAD27'],
            ['ZRX', '0xE41d2489571d322189246DaFA5ebDe1F4699F498'],
        ],
    },
};
const cc = require('cryptocompare')

const getTokenInfo = () => {
    return window.web3.eth.net.getId()
        .then((id) => {
            console.log("GETTING ID", id)
            let selectedNetwork
            switch (id) {
                case 1:
                    selectedNetwork = MAIN;
                    break;
                case 4:
                    selectedNetwork = RINKEBY;
                    break;
                default:
                    break;
            }
            if (selectedNetwork) {
                let tokenList = []
                let addressObject = selectedNetwork.tokenAddresses.addresses
                for (let i = 0; i < addressObject.length; i++) {
                    tokenList.push(addressObject[i][0])
                }
                let processedAddresses = []
                cc.priceFull([...tokenList, 'ETH'], 'USD')
                    .then(prices => {
                        console.log(prices)
                        for (let i = 0; i < tokenList.length; i++) {
                            let symbol = tokenList[i]
                            if (prices[symbol] != undefined) {
                                processedAddresses.push({
                                    symbol: symbol,
                                    price: prices[symbol]["USD"]["PRICE"],
                                    supply: prices[symbol]["USD"]["SUPPLY"],
                                    mktCap: prices[symbol]["USD"]["MKTCAP"],
                                    volume24Hour: prices[symbol]["USD"]["VOLUME24HOUR"],
                                    change24Hour: prices[symbol]["USD"]["CHANGEPCT24HOUR"].toFixed(2),
                                    tokenAddresses: selectedNetwork.tokenAddresses.addresses[i][1],
                                    exchangeAddress: selectedNetwork.exchangeAddresses.addresses[i][1],
                                    ratio: 0
                                })
                            }
                        }
                    })
                    .catch(console.error)
                console.log("PROCESSED")
                console.log(processedAddresses)
                return processedAddresses
            }
        });
}
module.exports = getTokenInfo;